"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * rendu de l'input avec la valeur choisie
 */
ngModule.directive("tlSelectSelectedOption", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<div class="tl-select-selection-option tl-select-option tl-validated-input" ng-class="{\'disabled\':disabled}">' + '<tl-circular-loader class="xs" ng-if="!$select.state.loadingRenderDone"></tl-circular-loader>' + '</div>',
    require: "^tlSelect",
    link: function link($scope, $el, $attrs, selectCtrl) {
      var optionScope = null,
        optionEl = null;
      $scope.$watch("$select.state.selectedOption", function (selectedOption) {
        var optionTranscludeFn = selectCtrl.getOptionTranscludeFn();
        if (optionScope != null) {
          optionScope.$destroy();
          optionScope = null;
        }
        if (optionEl != null) {
          optionEl.remove();
          optionEl = null;
        }
        if (selectedOption != null) {
          optionScope = $scope.$new();
          optionScope.option = selectedOption;
          if (selectedOption.$empty) {
            optionEl = $("<span>").addClass("empty-label").text(selectedOption.label).appendTo($el);

            // todo - doit etre placé là où la liste se construit
            $scope.loadingRenderDone = true;
            selectCtrl.state.loadingRenderDone = true;
          } else {
            optionTranscludeFn(optionScope, function (clone) {
              optionEl = clone.appendTo($el);
              // todo - doit plutot etre placé là où la liste se construit
              $scope.loadingRenderDone = true;
              selectCtrl.state.loadingRenderDone = true;
            });
          }
        } else {
          // pas de rendu prévu pour la valeur absente
          // TODO : placeholder ?
          optionEl = $("<span>").html("&nbsp;").appendTo($el);
          if (selectCtrl.source === undefined || !selectCtrl.state.sourceLoaded) {} else {
            $scope.loadingRenderDone = true;
            selectCtrl.state.loadingRenderDone = true;
          }
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/tlSelectSelectedOption.js
// module id = 3000
// module chunks = 13